<template>
  <Fragment>
    <Breadcrumb />
    <section class="mt-20">
      <el-tabs type="card">
        <el-tab-pane label="网址">
          <WebSiteInfo />
        </el-tab-pane>
        <el-tab-pane label="名片">
          <CardInfo />
        </el-tab-pane>
        <el-tab-pane label="文件">
          <FileInfo />
        </el-tab-pane>
        <el-tab-pane label="文本">
          <TextInfo />
        </el-tab-pane>
      </el-tabs>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import Breadcrumb from "@/components/Breadcrumb";
import CardInfo from "./cardInfo";
import FileInfo from "./fileInfo";
import TextInfo from "./textInfo";
import WebSiteInfo from "./webSiteInfo";

export default {
  components: {
    Fragment,
    Breadcrumb,
    // eslint-disable-next-line vue/no-unused-components
    CardInfo,
    // eslint-disable-next-line vue/no-unused-components
    FileInfo,
    // eslint-disable-next-line vue/no-unused-components
    TextInfo,
    WebSiteInfo
  }
};
</script>

<style lang="scss" scoped></style>
